import { Button, Container, TextInput } from "../ui/pageElements";

const HEADER_CONTAINER = "cameraListHeaderContainer";
const LIST_CONTAINER = "cameraListContainer";

export class CameraInterface {
    constructor(interfaces) {
        this.interfaces = interfaces;
        this.viewCount = 1;

        let buttonContainer = new Container("cameraButtonsContainer", HEADER_CONTAINER)
        this.addCameraViewButton = new Button("Add View", HEADER_CONTAINER, () => {
            this.addCameraView();
        })
        this.addCameraViewButton.setToolTip(this.interfaces.tooltips.addView, "rightToolTip");

        this.takePictureButton = new Button("Take Picture", HEADER_CONTAINER, () => {
            this.savePicture();
        })
        buttonContainer.addBlock(this.addCameraViewButton, this.takePictureButton);
        this.cameraViews = [];
    }

    addCameraView(viewData = null) {
        let view;
        if (viewData) {
            view = viewData;
        }
        else {
            view = {
                cameraPos: this.interfaces.controls.object.position.clone(),
                cameraLookAt: this.interfaces.controls.target.clone(),
                cameraZoom: this.interfaces.controls.object.zoom
            }
        }

        let viewContainer = new Container("viewContainer", LIST_CONTAINER, true);
        let viewNameText = new TextInput("View Name", LIST_CONTAINER, "View " + this.viewCount);
        viewNameText.removeElement(0);
        viewNameText.removeElement(0);
        this.viewCount++;

        let gotoViewButton = new Button("Go To View", LIST_CONTAINER, () => {
            this.updateControls(view);
        })
        let updateViewButton = new Button("Update View", LIST_CONTAINER, () => {
            view.cameraPos.copy(this.interfaces.controls.object.position);
            view.cameraLookAt.copy(this.interfaces.controls.target);
            view.cameraZoom = this.interfaces.controls.object.zoom;
        })
        let removeViewButton = new Button("Remove View", LIST_CONTAINER, () => {
            let index = this.cameraViews.indexOf(view);
            this.cameraViews.splice(index, 1);
            viewContainer.removeDiv();
        })

        viewContainer.addBlock(viewNameText, gotoViewButton, updateViewButton, removeViewButton);

        this.cameraViews.push(view)
    }

    updateControls(view) {
        // copied from orbit controls reset() method
        let pos = view.cameraPos;
        this.interfaces.controls.object.position.copy(pos);
        let lookAt = view.cameraLookAt;
        this.interfaces.controls.target.copy(lookAt);
        this.interfaces.controls.object.zoom = view.cameraZoom;
        this.interfaces.controls.object.updateProjectionMatrix();
        this.interfaces.controls.dispatchEvent({ type: 'change' });
        this.interfaces.controls.update();
    }

    savePicture() {
        console.log("taking picture");

        // https://stackoverflow.com/questions/26193702/three-js-how-can-i-make-a-2d-snapshot-of-a-scene-as-a-jpg-image
        let saveAsImage = () => {
            var strDownloadMime = "image/octet-stream";
            var imgData;
            try {
                var strMime = "image/jpeg";
                imgData = this.interfaces.renderer.domElement.toDataURL(strMime);
                let saveFile = (strData, filename) => {
                    var link = document.createElement('a');
                    if (typeof link.download === 'string') {
                        document.body.appendChild(link); //Firefox requires the link to be in the body
                        link.download = filename;
                        link.href = strData;
                        link.click();
                        document.body.removeChild(link); //remove the link when done
                    } else {
                        location.replace(uri);
                    }
                }
                saveFile(imgData.replace(strMime, strDownloadMime), "test.jpg");
            } catch (e) {
                console.log(e);
                return;
            }
        }

        saveAsImage();
    }

    getCameraViewData() {
        return this.cameraViews;
    }
}